import { useContext } from 'react'

import StandaloneViewportContext from '@contexts/standaloneViewport'

const useIsInStanstalonePage = (): boolean =>
  !!useContext(StandaloneViewportContext)

export default useIsInStanstalonePage
